import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBCarousel,
  MDBCarouselInner,MDBCarouselItem, MDBAlert, MDBTable, MDBTableBody, MDBTableHead, MDBBadge  } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView, MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBCardHeader, MDBDataTable } from 'mdbreact';
import { Form, Input, Button, Checkbox, message,Divider  } from 'antd';

import Axios from 'axios'

import Swal from 'sweetalert2'
import { api } from '../../api';


import LoadingOverlay from 'react-loading-overlay';
import Timeend from './Timeend';




export default class Roomshowstatus extends Component {
    

        constructor(props) {
            super(props);
            this.state = {
                value: '',
                Psaaword:'',
                modal: false,
                collapse: false,
                isWideEnough: false,

                code:'',
                bd:'',
                OLDID:'',
                BDATE:'',
                PNAME:'',
                NAME:'',
                FACULTY:'',
                price600:[],
                price500:[],
                price350:[],
                price290:[],
                authscore:[],
                authcount:'',
                studentcheck:[],
                work:[],
                room:[],
                room2:[],
                room3:[],
                loading:false,
            };
           
            this.handleSubmitstu = this.handleSubmitstu.bind(this);
            this.toggle = this.toggle.bind(this);
            this.onClick = this.onClick.bind(this);
            this.onTextChange = this.onTextChange.bind(this);
            this.getwork = this.getwork.bind(this);
            this.gotocheck = this.gotocheck.bind(this);
            this.senttomanufacture = this.senttomanufacture.bind(this);
            this.sentpdf = this.sentpdf.bind(this);
             this.getroom = this.getroom.bind(this);

           
          
            
          }

          onClick() {
            this.setState({
              collapse: !this.state.collapse,
            });
          }

          toggle = () => {
            this.setState({
              modal: !this.state.modal
            });
          }

          onTextChange = (e) => {
            this.setState({ [e.target.name]: e.target.value })
         }

        //  getscore (){
        //     api.get('selectauthscore.php?id_authorities='+localStorage.getItem('id_authorities'))
        //     .then(res => {
        //     //  console.log(res);
        //     //  this.setState({ bankname: res.data, loading: false })
        //       this.setState({ authscore: res.data})
        //     }) 
        // }

        gotocheck(event) {

         //   console.log(event.target.value);
            const id = event.target.value;
            window.location.href = '/sorlalum/Checkstudentlist/'+id;

        }

        getwork (){
          this.setState({ loading:true})
        
            api.get('selectworkslforgraphic.php')
            .then(res => {
            //  console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ work: res.data, loading: false })
            }) 
        }

        getroom (){
            this.setState({ loading:true})
          
              api.get('selectroomstatus1.php')
              .then(res => {
              //  console.log(res);
              //  this.setState({ bankname: res.data, loading: false })
              const filtered = res.data.filter(employee => { return employee.price === '600'; });
              const filter500 = res.data.filter(employee => { return employee.price === '500'; });
              const filter350 = res.data.filter(employee => { return employee.price === '350'; });
              const filter290 = res.data.filter(employee => { return employee.price === '290'; });
                this.setState({ room: res.data,
                                price600:filtered,
                                price500:filter500,
                                price350:filter350,
                                price290:filter290,
                                loading: false
                   })


              }) 

              api.get('selectroomstatus2.php')
              .then(res => {
              //  console.log(res);
              //  this.setState({ bankname: res.data, loading: false })
                this.setState({ room2: res.data, loading: false })
              }) 

              api.get('selectroomstatus3.php')
              .then(res => {
              //  console.log(res);
              //  this.setState({ bankname: res.data, loading: false })
                this.setState({ room3: res.data, loading: false })
              }) 
          }

        sentpdf(event) {
          const id = event.target.value;
          setTimeout(() => {
            window.open('https://lookmaenamping.com/sorlalumbackend/TCPDF-main/slfrom.php?id_workorder='+id+'', '_blank');
             // window.location.href ='http://localhost/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+this.state.idemp 
           }, 0);
        }
       

        senttomanufacture(event) {
          //  console.log(event.target.value);
            const date = new Date().toISOString().slice(0, 10)
            const gg = event.target.value

            Swal.fire({
              title: 'ยืนยัน',
              text: "ส่งไปยังฝ่ายผลิต",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'ตกลง',
             cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                 if (result.isConfirmed) {

                    setTimeout(() => {
        
                        const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                        datafrm.append("id", gg);
                        datafrm.append("datesent", date);
                        api.post("updatesenttomanufacture.php",datafrm,{
                         headers: {
                                   'content-type': 'multipart/form-data'
                                  }
                                  })
                                          .then(res => {
                                             // console.warn(res);
                                             // console.log("response: ", res)
                                              if (res.status=== 200) {
            
                                            Swal.fire({
                                              title: 'ส่งไปยังฝ่ายผลิตสำเร็จ',
                                              icon: 'success',
                                            // showCancelButton: true,
                                              confirmButtonText: 'ตกลง',
                                            // cancelButtonText: 'No, keep it'
                                            }).then((result) => {
                                              this.getwork();
                                             // window.location.href = '/'
                                            })
                  
                                              }else{
                                              // window.location.href = '/'
                                              }
                  
                                          })
                  
                              }, 1000);
                  
                 // console.log('ok')
                  } else if (result.isDenied) {
                   // Swal.fire('Changes are not saved', '', 'info')
                  }
            })
         
           }
     


          handleSubmitstu() {
            // alert('A name was submitted: ' + this.state.value);
           setTimeout(() => {
        
              const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
              datafrm.append("OLDID", this.state.OLDID);
              datafrm.append("BDATE", this.state.BDATE);
              datafrm.append("PNAME", this.state.PNAME);
              datafrm.append("NAME", this.state.NAME);
              datafrm.append("FACULTY", this.state.FACULTY);
        
              api.post("insertstudent.php",datafrm,{
                                    headers: {
                                        'content-type': 'multipart/form-data'
                                    }
                                })
        
                                .then(res => {
                                  //  console.warn(res);
                                   // console.log("response: ", res)
                                    if (res.status=== 200) {
  
                                  Swal.fire({
                                    title: 'ยืนยันลงทะเบียนสำเร็จ',
                                    icon: 'success',
                                  // showCancelButton: true,
                                    confirmButtonText: 'ตกลง',
                                  // cancelButtonText: 'No, keep it'
                                  }).then((result) => {
                                    this.toggle();  
                                    window.location.href = '/kprurun2021'
                                  })
        
                                    }else{
                                    // window.location.href = '/'
                                    }
        
                                })
        
                    }, 1000);
        
        //window.location.href = '/adminfaculty'
        //this.props.updateat();
        //this.getExpert()
        
          }

          componentDidMount (){
            if (localStorage.getItem('name') == null ) {
                window.location.href = 'https://lookmaenamping.com/sorlalum'
            } else {
  
            }
              this.getroom();
             // this.getstucount();
          }
        

 

    render() {
      console.log(this.state.price600)
//      var d = new Date(date),
//      month = '' + (d.getMonth() + 1),
//      day = '' + d.getDate(),
//      year = d.getFullYear();
//const date = new Date().toISOString().slice(0, 10)
//  if (month.length < 2) 
//      month = '0' + month;
//  if (day.length < 2) 
//      day = '0' + day;

//            const date = year + '-' + month + '-' + day;
     //console.log(date)
     const data = {
        columns: [
          {
            label: 'ลำดับ',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'เลขที่ห้อง',
            field: 'numberroom',
            sort: 'numberroom',
            width: 270
          },
          {
            label: 'ราคา',
            field: 'price',
            sort: 'price',
            width: 200
          },
         
          {
            label: 'สถานะขณะนี้',
            field: 'statusroom',
            sort: 'statusroom',
            width: 100
          }
          

        ],

        rows: [...this.state.room.map((data, i) => (
          {
             list: <>{i+1}</>,
             numberroom: <>{data.numberroom}</>,
             price: <>{data.price}</>,
             statusroom: <>ว่าง</>
            //  random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,

          }
         ))] 
    
    };

    const data2 = {
        columns: [
          {
            label: 'ลำดับ',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'เลขที่ห้อง',
            field: 'numberroom',
            sort: 'numberroom',
            width: 270
          },
          {
            label: 'ราคา',
            field: 'price',
            sort: 'price',
            width: 200
          },
         
          {
            label: 'สถานะขณะนี้',
            field: 'statusroom',
            sort: 'statusroom',
            width: 100
          }
          

        ],

        rows: [...this.state.room2.map((data, i) => (
          {
             list: <>{i+1}</>,
             numberroom: <>{data.numberroom}</>,
             price: <>{data.price}</>,
             statusroom: <>เข้าพัก <br/> <Timeend id_room={data.id_room} /></>
            //  random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,

          }
         ))] 
    
    };

    const data3 = {
        columns: [
          {
            label: 'ลำดับ',
            field: 'list',
            sort: 'list',
            width: 150
          },
          {
            label: 'เลขที่ห้อง',
            field: 'numberroom',
            sort: 'numberroom',
            width: 270
          },
          {
            label: 'ราคา',
            field: 'price',
            sort: 'price',
            width: 200
          },
         
          {
            label: 'สถานะขณะนี้',
            field: 'statusroom',
            sort: 'statusroom',
            width: 100
          }
          

        ],

        rows: [...this.state.room3.map((data, i) => (
          {
             list: <>{i+1}</>,
             numberroom: <>{data.numberroom}</>,
             price: <>{data.price}</>,
             statusroom: <>ทำความสะอาด</>
            //  random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,

          }
         ))] 
    
    };

    const persons = <MDBDataTable
   // searching ={true}
    searchLabel="ค้นหา รายการ"
    striped
    bordered
    small 
    entries={10}
   // entriesOptions={["10", "20"]}
    order={["age", "desc"]}
    data={data}
    entriesLabel="จำนวนที่แสดง "
    infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
    paginationLabel={["ย้อนกลับ", "ถัดไป"]}
    responsive 
    sortRows={['random']}
/>

const persons2 = <MDBDataTable
// searching ={true}
 searchLabel="ค้นหา รายการ"
 striped
 bordered
 small 
 entries={10}
// entriesOptions={["10", "20"]}
 order={["age", "desc"]}
 data={data2}
 entriesLabel="จำนวนที่แสดง "
 infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
 paginationLabel={["ย้อนกลับ", "ถัดไป"]}
 responsive 
 sortRows={['random']}
/>

const persons3 = <MDBDataTable
// searching ={true}
 searchLabel="ค้นหา รายการ"
 striped
 bordered
 small 
 entries={10}
// entriesOptions={["10", "20"]}
 order={["age", "desc"]}
 data={data3}
 entriesLabel="จำนวนที่แสดง "
 infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
 paginationLabel={["ย้อนกลับ", "ถัดไป"]}
 responsive 
 sortRows={['random']}
/>
      

        return (
       
          <LoadingOverlay
  active={this.state.loading}
  spinner
  text='Loading your data...'
  >
                <MDBContainer fluid >
                
  <h2 className="font-weight-bold  text-center">  รายการสถานะเข้าพัก</h2>
<p className="text-right">   สวัสดี {localStorage.getItem('name')} : ผู้ใช้งาน</p>
      <MDBRow >
          {/* <div >
              <Modaladdwork/> 
          </div> */}
       
        <MDBCol md="12" className="d-flex justify-content-center">
        <MDBCard style={{ width: "100%", marginTop: "1rem" }}>
                    <MDBCardBody>
                    {/* <MDBCardTitle className="text-center">  จัดการห้องพัก</MDBCardTitle> */}
                    <MDBRow>
        <MDBCol sm="4"> 
          <MDBCard color="info-color" text="white" className="text-center">
            <MDBCardBody>
            <h1 className="white-text">ห้องว่าง {this.state.room.length}</h1>
            </MDBCardBody>
          </MDBCard>
            {/* {persons} */}
            <MDBCard className="card-body" style={{  marginTop: "1rem" }}>
              <MDBCardTitle>ห้อง 600 บาท ว่าง {this.state.price600.length} ห้อง</MDBCardTitle>
              <MDBCardText>
              {this.state.price600.map((price600,index )  => {
                  return <><span><MDBBadge color="default">ห้องที่ {price600.numberroom} </MDBBadge> </span> </>
              } )}
              </MDBCardText>
            </MDBCard>

            <MDBCard className="card-body" style={{  marginTop: "1rem" }}>
              <MDBCardTitle>ห้อง 500 บาท ว่าง {this.state.price500.length} ห้อง</MDBCardTitle>
              <MDBCardText>
              {this.state.price500.map((price500,index )  => {
                  return <><span><MDBBadge color="primary">ห้องที่ {price500.numberroom} </MDBBadge> </span> </>
              } )}
              </MDBCardText>
            </MDBCard>

            <MDBCard className="card-body" style={{  marginTop: "1rem" }}>
              <MDBCardTitle>ห้อง 350 บาท ว่าง {this.state.price350.length} ห้อง</MDBCardTitle>
              <MDBCardText>
              {this.state.price350.map((price350,index )  => {
                  return <><span><MDBBadge color="info">ห้องที่ {price350.numberroom} </MDBBadge> </span> </>
              } )}
              </MDBCardText>
            </MDBCard>

            <MDBCard className="card-body" style={{  marginTop: "1rem" }}>
              <MDBCardTitle>ห้อง 290 บาท ว่าง {this.state.price290.length} ห้อง</MDBCardTitle>
              <MDBCardText>
              {this.state.price290.map((price290,index )  => {
                  return <><span><MDBBadge color="secondary">ห้องที่ {price290.numberroom} </MDBBadge> </span> </>
              } )}
              </MDBCardText>
            </MDBCard>


          </MDBCol>
        <MDBCol sm="4">
          <MDBCard color="danger-color-dark" text="white" className="text-center">
            <MDBCardBody>
            <h1 className="white-text">ห้องเข้าพัก {this.state.room2.length}</h1>
            </MDBCardBody>
          </MDBCard>
          {persons2}
        </MDBCol>
        <MDBCol sm="4">
          <MDBCard color="warning-color-dark" text="white" className="text-center">
            <MDBCardBody>
            <h1 className="white-text">ห้องทำความสะอาด {this.state.room3.length}</h1>
            </MDBCardBody>
          </MDBCard>
          {persons3}
        </MDBCol>
      </MDBRow>
                    <br/>
                    <div className='text-center'>
                        {/* <MDBBtn color="purple">ตรวจหลักฐาน</MDBBtn> */}
                    </div>
                     
                    </MDBCardBody>

                    {/* <MDBCardBody>
                    <MDBRow >
<p>asdsdfs</p>
</MDBRow>
                    </MDBCardBody>
  */}
  

                   
         </MDBCard>
        </MDBCol>


      </MDBRow>
      {/* SELECT tb_score.oldid_score, tb_score.num_score, tb_score.file_score, tb_score.date_score, tb_score.status_score, tb_student.PNAME, tb_student.NAME
FROM tb_score
INNER JOIN tb_student ON tb_score.oldid_score=tb_student.OLDID */}

<br/>


                   
                    </MDBContainer>
                   </LoadingOverlay>  
     
        )
    }
}
